// src/components/GoogleLoginButton.jsx
import React from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../utils/context";
import { auth, googleProvider, signInWithPopup } from "../../utils/firebase";
import { signUpUser, setQuota } from "../../api/userApi";

const GoogleLoginButton = () => {
  const { login } = useContext(UserContext);
  const navigate = useNavigate();
  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      const token = await user.getIdToken();

      // Update Global Context
      login({
        uid: user.uid,
        email: user.email,
        token,
      });

      // ALWAYS sync user data with backend to ensure fields like 'email' exist in Firestore
      signUpUser(user.uid, user.email);

      if (result.user.metadata.creationTime === result.user.metadata.lastSignInTime) { // new user
        setQuota(user.uid);
        console.log("New user signup!");
      }

      navigate("/main");
    } catch (error) {
      console.error("Login Error:", error);
      alert("Login failed");
    }
  };

  return (
    <button
      onClick={handleLogin}
      className="bg-white text-gray-800 border px-4 py-2 rounded-full shadow-md hover:shadow-lg transition flex items-center gap-2"
    >
      <img src="/assets/icons/google.png" alt="Google Logo" className="w-5 h-5" />
      <strong>Continue with Google</strong>
    </button>
  );
};

export default GoogleLoginButton;
